import { render, staticRenderFns } from "./CreateChallengePopup.vue?vue&type=template&id=6c0627e0&scoped=true&"
import script from "./CreateChallengePopup.vue?vue&type=script&lang=js&"
export * from "./CreateChallengePopup.vue?vue&type=script&lang=js&"
import style0 from "./CreateChallengePopup.vue?vue&type=style&index=0&id=6c0627e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0627e0",
  null
  
)

export default component.exports